export enum UserRoleEnum {
	ADMIN = '1',
	VENDOR_DIRECTOR = '2',
	VENDOR_CONTACT = '3',
	SUBSCRIBER = '4',
	PRESUBSCRIBER = '5',
}
